import { Grid } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { BsHeartPulse } from 'react-icons/bs';
import { PaperWithBorder } from 'components/PaperWithBorder';
import { BloodPressureInfoModal } from 'components/Modal/BloodPressureInfoModal';
import { DonutChart } from 'components/Charts/DonutChart/DonutChart';
import { ChartLabelPrefix, Orientation } from 'models/charts';
import { BloodPressureLegendModal } from 'components/Modal/BloodPressureLegendModal';
import { PatientDetailsDescriptionKeys } from 'models/measurement';
import { useBloodPressureOverview } from 'hooks/api/bloodpressure/useBloodPressureData';
import { PatientDetailsGrid } from '../../PatientDetailsGrid';
import { BloodPressureChart } from './BloodPressureChart';
import { BloodPressureCalendar } from './BloodPressureCalendar';

export const BloodPressureOverview = () => {
  const { t } = useTranslation();
  const { isEnabled, distributionValues, isLoading } = useBloodPressureOverview();

  return (
    <PatientDetailsGrid
      title={t('patients_tab_bloodpressure')}
      Icon={BsHeartPulse}
      pageDescriptionKey={PatientDetailsDescriptionKeys.BloodPressure}
      isEnabled={isEnabled}
    >
      <Grid.Col span={3}>
        <PaperWithBorder
          title={t('type_of_measurements_label')}
          infoModal={<BloodPressureInfoModal />}
          testId={'blood-pressure-donut'}
        >
          <DonutChart<string>
            data={distributionValues}
            layout={Orientation.Vertical}
            labelPrefix={ChartLabelPrefix.BloodPressure}
          />
        </PaperWithBorder>
      </Grid.Col>
      <Grid.Col span={9}>
        <PaperWithBorder
          title={t('blood_pressure_label')}
          infoModal={<BloodPressureLegendModal />}
          isLoading={isLoading}
          testId={'blood-pressure-chart'}
        >
          <BloodPressureChart />
        </PaperWithBorder>
      </Grid.Col>
      <Grid.Col span={12}>
        <BloodPressureCalendar />
      </Grid.Col>
    </PatientDetailsGrid>
  );
};
